import { isProductionOrStaging } from "@booking/utils/environment";
import { type StateCreator, create } from "zustand";
import { type PersistStorage, devtools, persist } from "zustand/middleware";

import { createAppSettingState } from "./appSetting/createAppSettingState";
import { createPaymentState } from "./payment/createPaymentState";
import { createRoomsState } from "./rooms/createRoomsState";
import { createRoundsState } from "./rounds/createRoundsState";
import { createSimpleTeeTimesState } from "./simpleTeeTimes/createSimpleTeeTimesState";
import type { BookingPersist, BookingState } from "./types";
import { deserializeStore, serializeStore } from "./utils";

const createBookingState: StateCreator<BookingState> = (...args) => ({
  ...createRoomsState(...args),
  ...createRoundsState(...args),
  ...createSimpleTeeTimesState(...args),
  ...createAppSettingState(...args),
  ...createPaymentState(...args),
});

const devToolsOptions = { enabled: !isProductionOrStaging() };

const persistOptions = {
  name: "ygt-booking",
  partialize: ({ rooms }: BookingState): BookingPersist => ({
    rooms,
  }),
  storage: {
    getItem: (name) => deserializeStore(localStorage.getItem(name)),
    setItem: (name, value) => localStorage.setItem(name, serializeStore(value)),
    removeItem: (name) => localStorage.removeItem(name),
  } as PersistStorage<BookingPersist>,
};

export const useBookingStore = create<BookingState>()(
  devtools(persist(createBookingState, persistOptions), devToolsOptions),
);
